import { reactive } from "vue";
import BzbsProfile from '@/core/Account/service/BzbsProfile';

const state = reactive({
    isInitial: false,
    profileLevel: null,
    point: 0,
});

const methods = {
    initProfileLevel: function () {
        return new Promise((resolve, reject) => {
            BzbsProfile.getProfileLevel().subscribe({
                next: (data) => {
                    // console.log(data);
                    state.profileLevel = data;
                    state.point = data.point;
                    state.isInitial = true;
                    resolve(data);
                },
                error: (err) => {
                    reject(err);
                    this.errorApi(err);
                },
            });
        });
    },
    getProifleLevel: function () {
        return new Promise((resolve, reject) => {
            if (state.isInitial) {
                resolve(state.profileLevel);
                return;
            }

            this.initProfileLevel().then((data) => {
                resolve(data);
            }).catch((err) => {
                reject(err);
            });
        });
    },

    updateProfileLevel: function () {
        return this.initProfileLevel();
    },
};

export default {
    state: state,
    methods: methods,
}
